module.exports = __webpack_public_path__ + "static/img/company18.f056b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company18.png
// module id = x+3t
// module chunks = 1